import { ECG_CONSTANTS } from '../utils/ecg-constants';
import { ILayerViewModel, ILayout } from '../models/interfaces';
import { ChangeDetectionComposer } from './changeDetectionComposer';

export class RelocateComposer<T> extends ChangeDetectionComposer<T> {
    // constructor
    constructor(layout: ILayout, defaultValue: T) {
        super(layout, defaultValue);
    }

    // pubblic functions

    public isChanged() {
        return true;
    }

    // protected functions

    protected onUpdate(layer: ILayerViewModel) {
        const dictionary: Map<string, number> = new Map<string, number>();
        const leadHeight = this.layout.context?.leadHeight ?? 0;
        const size = {
            width: this.layout.getSize().width,
            height: this.layout.getSize().height + layer.referenceTraces.length,
        };

        layer.visibleTraces.forEach((trace, index) => {
            const key = trace.step?.title ?? '';
            const dnc = size.height / 2 - (this.layout.getPosition(index).y + leadHeight / 2);
            const value = dnc * this.layout.ecgState.chartState.traceSpacing;
            dictionary.set(key, value);
        });
        layer.visibleReferenceTraces.forEach((trace, index) => {
            const key = trace.step?.title ?? '';
            const dnc = size.height / 2 - (this.layout.rows * leadHeight + index * leadHeight + leadHeight / 2);
            const value = dnc * this.layout.ecgState.chartState.traceSpacing;
            if(!dictionary.get(key)){
                dictionary.set(key,value);
            }
        });

        layer.visibleTraces.forEach((trace, index) => {
            const key = trace.step?.title ?? '';
            const value = dictionary.get(key) ?? 0;
            const position = this.layout.getPosition(index);
            position.y = size.height / 2 - value - leadHeight / 2;

            trace.translate =
                'translate(' + (position.x + 5) + ', ' + Math.ceil((position.y / 5000) * 5000).toString() + ')';
        });
        layer.visibleReferenceTraces.forEach((trace, index) => {
            const key = trace.step?.title ?? '';
            const position = {
                x: ECG_CONSTANTS.LEAD_SPACE_WIDTH,
                y: this.layout.rows * leadHeight + index * leadHeight,
            };
            const value = dictionary.get(key) ?? 0;
            position.y = size.height / 2 - value - leadHeight / 2;

            trace.translate =
                'translate(' + (position.x + 5) + ', ' + Math.ceil((position.y / 5000) * 5000).toString() + ')';
        });
    }
}
